import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import nine from '../assets/svg/projects/nine.svg'
import ten from '../assets/svg/projects/ten.svg'
import eleven from '../assets/svg/projects/eleven.svg'
import twelve from '../assets/svg/projects/twelve.svg'
import thirteen from '../assets/svg/projects/thirteen.svg'
import elefin from '../assets/svg/projects/elefin.png'
import fitnessmanagement from '../assets/svg/projects/fitnessmanagement.png'
import safsHochschule from '../assets/svg/projects/safs-hochschule.svg'
import dhfpgBsa from '../assets/svg/projects/dhfpg-bsa.jpg'
import breuls from '../assets/svg/projects/breuls.png'
import rsSports from '../assets/svg/projects/rs-sports.png'
import demetz from '../assets/svg/projects/demetz.svg'
import prike from '../assets/svg/projects/prike.svg'
import hinno from '../assets/svg/projects/hinno.png'
import zibra from '../assets/svg/projects/zibra.png'
import veneko from '../assets/svg/projects/veneko.png'
import ciela from '../assets/svg/projects/ciela.png'
import iabon from '../assets/svg/projects/iabon.png'
import magoware from '../assets/svg/projects/magoware.png'
import postIcu from '../assets/svg/projects/post-icu.png'
import retailr from '../assets/svg/projects/retailr.png'
import tibo from '../assets/svg/projects/tibo.png'
import btcswe from '../assets/svg/projects/btcswe.png'
import lanero from '../assets/svg/projects/lanero.svg'
import holaluz from '../assets/svg/projects/holaluz.svg'
import dieMitte from '../assets/svg/projects/die-mitte.svg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Fitness Management',
        projectDesc: 'German fitness industry publication platform with custom WordPress development and Figma-designed layouts.',
        tags: ['WordPress', 'Elementor Pro', 'PHP', 'ACF', 'Figma'],
        searchTags: ['WordPress', 'Elementor Pro', 'PHP', 'ACF', 'Figma'],
        code: '',
        demo: 'https://fitnessmanagement.de',
        image: fitnessmanagement
    },
    {
        id: 2,
        projectName: 'SAFS Hochschule',
        projectDesc: 'Swiss Academy of Fitness & Sports offering dual bachelor programs in fitness economics and training.',
        tags: ['WordPress', 'Elementor Pro', 'PHP', 'ACF', 'Figma'],
        searchTags: ['WordPress', 'Elementor Pro', 'PHP', 'ACF', 'Figma'],
        code: '',
        demo: 'https://www.safs-hochschule.ch/',
        image: safsHochschule
    },
    {
        id: 3,
        projectName: 'Post-ICU Digital Diary',
        projectDesc: 'Digital healthcare solution for post-intensive care patients and families. Comprehensive ICU diary platform trusted by 25+ European hospitals, reducing readmissions, improving patient outcomes, and enabling personalized recovery documentation.',
        tags: ['WordPress', 'PHP', 'MySQL', 'JavaScript', 'CSS'],
        searchTags: ['WordPress', 'PHP', 'MySQL', 'JavaScript', 'CSS'],
        code: '',
        demo: 'https://post-icu.com/',
        image: postIcu
    },
    {
        id: 4,
        projectName: 'DHfPG-BSA - Health & Fitness Education Platform',
        projectDesc: 'German university platform for prevention, fitness, sports, and health management education. Features dual bachelor programs, professional certifications, and comprehensive course management system for health and fitness industry training.',
        tags: ['WordPress', 'PHP', 'MySQL', 'JavaScript', 'CSS', 'Elementor Pro'],
        searchTags: ['WordPress', 'PHP', 'MySQL', 'JavaScript', 'CSS', 'Elementor Pro'],
        code: '',
        demo: 'https://www.dhfpg-bsa.de/',
        image: dhfpgBsa
    },
    {
        id: 5,
        projectName: 'Breuls Fietshandel',
        projectDesc: 'Belgian bicycle shop established in 1931, specializing in e-bikes, speed bikes, and comprehensive bike services.',
        tags: ['WordPress', 'Elementor Pro', 'WooCommerce', 'PHP', 'Figma'],
        searchTags: ['WordPress', 'Elementor Pro', 'WooCommerce', 'PHP', 'Figma'],
        code: '',
        demo: 'https://www.breuls.be',
        image: breuls
    },
    {
        id: 6,
        projectName: 'RS Sports Store',
        projectDesc: 'Swedish sports equipment and apparel e-commerce platform specializing in tennis and padel gear. Shopify-based store featuring seasonal collections, professional sports equipment, and performance apparel for men, women, and juniors.',
        tags: ['Shopify', 'Liquid', 'JavaScript', 'CSS', 'HTML'],
        searchTags: ['Shopify', 'Liquid', 'JavaScript', 'CSS', 'HTML'],
        code: '',
        demo: 'https://rs-sports.com/',
        image: rsSports
    },
    {
        id: 7,
        projectName: 'QR Product details',
        projectDesc: 'Comprehensive WordPress plugin for Austrian plastic manufacturing company. Features custom post types, QR code functionality, product combinations management, and advanced admin interface with DataTables integration.',
        tags: ['WordPress', 'PHP', 'Custom Plugin', 'ACF', 'MySQL', 'DataTables'],
        searchTags: ['WordPress', 'PHP', 'Custom Plugin', 'ACF', 'MySQL', 'DataTables'],
        code: '',
        demo: 'https://dk-demetz.at',
        image: demetz
    },
    {
        id: 8,
        projectName: 'Beverage Distribution',
        projectDesc: 'Leading Baltic beverage distribution platform representing world-renowned brands and LVMH. Operating across Estonia, Latvia, and Lithuania since 1992 with comprehensive e-commerce and brand management solutions.',
        tags: ['WordPress', 'PHP', 'E-commerce', 'Brand Management', 'MySQL', 'JavaScript'],
        searchTags: ['WordPress', 'PHP', 'E-commerce', 'Brand Management', 'MySQL', 'JavaScript'],
        code: '',
        demo: 'https://prike.ee/',
        image: prike
    },
    {
        id: 9,
        projectName: 'Geolocation Store Locator',
        projectDesc: 'Advanced WordPress plugin for Swiss curtain supplier management. Features Excel import, geocoding integration, DataTables interface, and comprehensive supplier data management with export capabilities.',
        tags: ['WordPress', 'PHP', 'Custom Plugin', 'PhpSpreadsheet', 'MySQL', 'Geocoding API'],
        searchTags: ['WordPress', 'PHP', 'Custom Plugin', 'PhpSpreadsheet', 'MySQL', 'Geocoding API'],
        code: '',
        demo: 'https://hinno.ch/bezugsquellen-finder/',
        image: hinno
    },
    {
        id: 10,
        projectName: 'Zibra Sport Equest',
        projectDesc: 'Danish digital equestrian universe providing comprehensive horse sport coverage, streaming services, articles, and event management. Features live streaming via ClipMyHorse integration, social media content creation.',
        tags: ['WordPress', 'PHP', 'Media Streaming', 'Content Management', 'Social Media Integration', 'Event Coverage'],
        searchTags: ['WordPress', 'PHP', 'Media Streaming', 'Content Management', 'Social Media Integration', 'Event Coverage'],
        code: '',
        demo: 'https://zibrasportequest.com/',
        image: zibra
    },
    {
        id: 11,
        projectName: 'VENEKO - Energy Legal Tech Platform',
        projectDesc: 'German legal-tech platform helping consumers with energy billing disputes and premium energy management services. Shopify-based system for processing ExtraEnergie refund claims, with automated document processing and success-based billing.',
        tags: ['Shopify', 'Liquid', 'JavaScript', 'CSS', 'HTML'],
        searchTags: ['Shopify', 'Liquid', 'JavaScript', 'CSS', 'HTML'],
        code: '',
        demo: 'https://veneko.de/',
        image: veneko
    },
    {
        id: 12,
        projectName: 'Ciela Science Institute',
        projectDesc: 'Montreal Institute for Astrophysics and Machine Learning. Research institute website associated with Université de Montréal, developing computational data analysis methods for astrophysics breakthrough discoveries.',
        tags: ['WordPress', 'PHP', 'MySQL', 'JavaScript', 'CSS'],
        searchTags: ['WordPress', 'PHP', 'MySQL', 'JavaScript', 'CSS'],
        code: '',
        demo: 'https://ciela.science/',
        image: ciela
    },
    {
        id: 13,
        projectName: 'IA BON - Swedish Jewelry Brand',
        projectDesc: 'Premium Swedish e-commerce platform for elevated hair accessories and jewelry. Shopify-based online store featuring baroque pearl earrings, tennis collections, hair claws, and Scandinavian-inspired jewelry with international shipping.',
        tags: ['Shopify', 'Liquid', 'JavaScript', 'CSS', 'HTML'],
        searchTags: ['Shopify', 'Liquid', 'JavaScript', 'CSS', 'HTML'],
        code: '',
        demo: 'https://iabon.se/',
        image: iabon
    },
    {
        id: 14,
        projectName: 'KBH terapeuterne Room booking',
        projectDesc: 'Meeting Room Booking System for KBH Terapeuterne - a comprehensive room reservation system for therapy rooms across three locations in Copenhagen',
        tags: ['PHP', 'MySQL', 'jQuery', 'PHPMailer'],
        searchTags: ['PHP', 'MySQL', 'jQuery', 'PHPMailer'],
        code: '',
        demo: 'https://www.kbhterapeuterne.dk/',
        image: two
    },
    {
        id: 15,
        projectName: 'IPTV/OTT Platform',
        projectDesc: 'Comprehensive IPTV/OTT software solution for video content management and distribution. Features lightweight middleware, integrations with thousands of apps, and scalable platform for pay TV operators, broadcasters, and content providers.',
        tags: ['IPTV', 'OTT', 'Video Streaming', 'Content Management', 'APIs', 'Cloud Platform'],
        searchTags: ['IPTV', 'OTT', 'Video Streaming', 'Content Management', 'APIs', 'Cloud Platform'],
        code: '',
        demo: 'https://www.magoware.tv/',
        image: magoware
    },
    {
        id: 16,
        projectName: 'Retailr - Local Fashion Marketplace',
        projectDesc: 'Swedish local fashion e-commerce platform connecting local clothing stores with online shoppers. Multi-vendor marketplace featuring curated collections from local retailers, supporting community commerce with seamless online shopping experience.',
        tags: ['WordPress', 'WooCommerce', 'PHP', 'MySQL', 'JavaScript'],
        searchTags: ['WordPress', 'WooCommerce', 'PHP', 'MySQL', 'JavaScript'],
        code: '',
        demo: 'https://retailr.se/',
        image: retailr
    },
    {
        id: 17,
        projectName: 'TiBO IPTV',
        projectDesc: 'Angular subscription management application for TiBO IPTV services across Europe. Features device selection, package management, Chargebee payment processing, and multi-language support for Albanian/English customers.',
        tags: ['Angular', 'TypeScript', 'Chargebee'],
        searchTags: ['Angular', 'TypeScript', 'Chargebee'],
        code: '',
        demo: 'https://www.tibo.tv/abonohu-eu/',
        image: tibo
    },
    {
        id: 18,
        projectName: 'BTCSWE Crypto',
        projectDesc: 'WordPress/WooCommerce cryptocurrency trading platform for Bitcoin Sweden. Features live Bitcoin prices via BitcoinAverage API, custom crypto product types, real-time currency conversion, and secure cryptocurrency transactions.',
        tags: ['WordPress', 'WooCommerce', 'PHP', 'MySQL', 'BitcoinAverage API'],
        searchTags: ['WordPress', 'WooCommerce', 'PHP', 'MySQL', 'BitcoinAverage API'],
        code: '',
        demo: 'https://btcswe.com',
        image: btcswe
    },
    {
        id: 19,
        projectName: 'Full-Stack Booking Platform',
        projectDesc: 'Full-stack appointment booking platform for businesses. Angular frontend with Symfony API backend, featuring calendar management, JWT authentication.',
        tags: ['Angular', 'TypeScript', 'Symfony', 'PHP', 'MySQL', 'Twig', 'TailwindCSS'],
        searchTags: ['Angular', 'TypeScript', 'Symfony', 'PHP', 'MySQL', 'Twig', 'TailwindCSS'],
        code: '',
        demo: '',
        image: one
    },
    {
        id: 20,
        projectName: 'WordPress Comparison Plugin',
        projectDesc: 'Advanced WordPress plugin for comparison listings and reviews. Features custom post types, ACF integration, statistics dashboard, filtering system, and MDB Bootstrap components for comparison tables and user interfaces.',
        tags: ['WordPress', 'PHP', 'ACF', 'MySQL', 'JavaScript'],
        searchTags: ['WordPress', 'PHP', 'ACF', 'MySQL', 'JavaScript'],
        code: '',
        demo: 'https://xn--lnero-mra.se/',
        image: lanero
    },
    {
        id: 21,
        projectName: 'Pricing Management',
        projectDesc: 'Symfony-based pricing management system with OAuth2 authentication and RESTful API integration. Features product catalog management, dynamic price list creation, dashboard analytics, and comprehensive pricing workflow automation.',
        tags: ['Symfony', 'PHP', 'Twig', 'OAuth2', 'GuzzleHttp', 'MySQL'],
        searchTags: ['Symfony', 'PHP', 'Twig', 'OAuth2', 'GuzzleHttp', 'MySQL'],
        code: '',
        demo: 'https://alta.holaluz.com/',
        image: holaluz
    },
    {
        id: 22,
        projectName: 'Die Mitte - Swiss Political Party Platform',
        projectDesc: 'Comprehensive multilingual WordPress platform. Features advanced WPML integration, multisite architecture, people management system with API integration, event management, and custom post types for political content.',
        tags: ['WordPress', 'WPML', 'PHP', 'Multisite', 'ACF', 'REST API'],
        searchTags: ['WordPress', 'WPML', 'PHP', 'Multisite', 'ACF', 'REST API'],
        code: '',
        demo: 'https://die-mitte.ch',
        image: dieMitte
    },
    {
        id: 23,
        projectName: 'Busmark - Full-Stack Business Platform',
        projectDesc: 'Complete business platform for social media marketing and website development services. Angular frontend, Symfony API backend with user management, subscription handling and integrated payment processing via Stripe.',
        tags: ['Angular', 'TypeScript', 'Symfony', 'PHP', 'MySQL', 'Stripe API'],
        searchTags: ['Angular', 'TypeScript', 'Symfony', 'PHP', 'MySQL', 'Stripe API'],
        code: '',
        demo: '',
        image: thirteen
    },
    {
        id: 24,
        projectName: 'Job Portal',
        projectDesc: 'Comprehensive job portal platform connecting employers and job seekers. Laravel API backend with authentication, job management, and application tracking. React frontend with responsive design, advanced search filters, and real-time job matching.',
        tags: ['React', 'JavaScript', 'Laravel', 'PHP', 'MySQL', 'CSS'],
        searchTags: ['React', 'JavaScript', 'Laravel', 'PHP', 'MySQL', 'CSS'],
        code: '',
        demo: '',
        image: eleven
    },
    {
        id: 25,
        projectName: 'Document Management Platform',
        projectDesc: 'Comprehensive Swiss document management SaaS platform built with Laravel. Multi-tenant architecture with Google Cloud SQL, mobile apps for iOS/Android, subscription-based service with document scanning and two-factor authentication.',
        tags: ['Laravel', 'PHP', 'Vue.js', 'MySQL', 'Google Cloud', 'SCSS'],
        searchTags: ['Laravel', 'PHP', 'Vue.js', 'MySQL', 'Google Cloud', 'SCSS'],
        code: '',
        demo: '',
        image: elefin
    },
    {
        id: 26,
        projectName: 'Manufacturing Management System',
        projectDesc: 'Comprehensive PHP-based manufacturing management system for textile/production industry. Features employee management, production planning, order tracking, payroll processing, quality control, inventory management, and detailed reporting.',
        tags: ['PHP', 'MySQL', 'Bootstrap', 'jQuery', 'CSS', 'HTML'],
        searchTags: ['PHP', 'MySQL', 'Bootstrap', 'jQuery', 'CSS', 'HTML'],
        code: '',
        demo: '',
        image: twelve
    },
    {
        id: 27,
        projectName: 'Stripe Klarna WooCommerce Gateway',
        projectDesc: 'Advanced WooCommerce payment gateway plugin integrating Stripe Klarna. Features webhook handling, automatic refunds, vendor payment distribution, multi-currency support, and comprehensive order processing.',
        tags: ['WordPress', 'WooCommerce', 'PHP', 'Stripe API', 'MySQL', 'JavaScript'],
        searchTags: ['WordPress', 'WooCommerce', 'PHP', 'Stripe API', 'MySQL', 'JavaScript'],
        code: '',
        demo: '',
        image: eleven
    },
    {
        id: 28,
        projectName: 'ENSYSCO Energy Pricing API',
        projectDesc: 'Enterprise-grade microservices API for energy sector pricing management. Symfony-based RESTful API with OAuth2 authentication. Features comprehensive contract management, price list automation, and Swagger documentation.',
        tags: ['Symfony', 'PHP', 'OAuth2', 'Doctrine ORM', 'MySQL', 'Swagger'],
        searchTags: ['Symfony', 'PHP', 'OAuth2', 'Doctrine ORM', 'MySQL', 'Swagger'],
        code: '',
        demo: '',
        image: ten
    },
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/